<template>
  <div class="flex flex-col h-full overflow-hidden">
    <!-- Call Count Display -->
    <div
      v-if="showCount"
      class="flex-shrink-0 ma-1 pa-1 font-weight-bold d-flex justify-end"
    >
      <span class="!bg-primary-900 pa-2 rounded-lg text-white">
        {{
          currentLocal == "ar"
            ? $t(getArabicPluralKey("plural.call", totalCount), totalCount)
            : $t("reports.total_performance_report.calls_count", totalCount)
        }}
      </span>
    </div>

    <!-- Progress Indicator -->
    <report-progress :showProgress="isLoading" />

    <!-- Table Container with Sticky Header -->
    <div class="flex-1 overflow-hidden">
      <div class="h-full flex flex-col">
        <!-- Single Table with Sticky Header -->
        <div class="flex-1 overflow-auto">
          <table class="w-full table-fixed text-sm">
            <thead class="sticky top-0 z-10">
              <tr>
                <th class="!bg-primary-900 text-white set-border text-center font-weight-medium rounded-s-lg px-2 py-2 w-1/8">
                  {{ $t("reports.total_performance_report.head_skill") }}
                </th>
                <th class="!bg-primary-900 text-white set-border text-center font-weight-medium px-2 py-2 w-1/8">
                  {{ $t("reports.total_performance_report.head_total") }}
                </th>
                <th class="!bg-primary-900 text-white set-border text-center font-weight-medium px-2 py-2 w-1/8">
                  {{ $t("reports.total_performance_report.head_offered") }}
                </th>
                <th class="!bg-primary-900 text-white set-border text-center font-weight-medium px-2 py-2 w-1/8">
                  {{ $t("reports.total_performance_report.head_success") }}
                </th>
                <th class="!bg-primary-900 text-white set-border text-center font-weight-medium px-2 py-2 w-1/8">
                  {{ $t("reports.total_performance_report.head_success_rate") }}
                </th>
                <th class="!bg-primary-900 text-white set-border text-center font-weight-medium px-2 py-2 w-1/8">
                  {{ $t("reports.total_performance_report.head_failed") }}
                </th>
                <th class="!bg-primary-900 text-white set-border text-center font-weight-medium rounded-e-lg px-2 py-2 w-1/8">
                  {{ $t("reports.total_performance_report.head_failed_rate") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(record, index) in reportData" :key="record.skill" 
                  :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'">
                <td class="text-center text-teal px-2 py-2 border-b border-gray-200 w-1/8">
                  {{
                    skills.find((skill) => skill.name === record.skill)
                      ? $i18n.locale === "ar"
                        ? skills.find((skill) => skill.name === record.skill).titles.ar
                        : skills.find((skill) => skill.name === record.skill).titles.en
                      : record.skill
                  }}
                </td>
                <td class="text-center text-grey-darken-1 px-2 py-2 border-b border-gray-200 w-1/8">
                  {{ record.total }}
                </td>
                <td class="text-center text-grey-darken-1 px-2 py-2 border-b border-gray-200 w-1/8">
                  {{ record.offered }}
                </td>
                <td :class="'text-center text-uppercase px-2 py-2 border-b border-gray-200 text-' + performanceState(record.success, true) + ' w-1/8'">
                  {{ record.success }}
                </td>
                <td :class="'text-center text-uppercase px-2 py-2 border-b border-gray-200 text-' + performanceState(record.success, true) + ' w-1/8'">
                  {{ percentage(record.success, record.offered) }}
                </td>
                <td :class="'text-center text-uppercase px-2 py-2 border-b border-gray-200 text-' + performanceState(record.lost, true) + ' w-1/8'">
                  {{ record.lost }}
                </td>
                <td :class="'text-center text-uppercase px-2 py-2 border-b border-gray-200 text-' + performanceState(record.lost, true) + ' w-1/8'">
                  {{ percentage(record.lost, record.offered) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportProgress from "../../components/ReportProgress.vue";

export default {
  name: "total_performance-report",
  components: {
    ReportProgress,
  },
  props: {
    selectedFilters: {
      type: Object,
      default: () => ({})
    },
    skills: {
      type: Array,
      default: () => []
    },
    reportData: {
      type: Array,
      default: () => []
    },
    totalCount: {
      type: Number,
      default: 0
    },
    showCount: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentLocal() {
      return this.$i18n.locale;
    },
  },
  methods: {
    toArabicNumerals(num) {
      return num.toString().replace(/\d/g, (d) => "٠١٢٣٤٥٦٧٨٩"[d]);
    },
    
    percentage(value, total) {
      if (total === 0) {
        return 0.0 + "%";
      } else if (total > 0) {
        let perct = (value / total) * 100;
        return Math.round(perct * 100) / 100 + "%";
      }
    },
    
    performanceState(stats, isSuccess) {
      if (!stats > 0) {
        return "grey-darken-1";
      }
      if (isSuccess) {
        return "success";
      } else {
        return "error";
      }
    },
  },
};
</script>

<style scoped>
.set-border {
  border: 2px solid #d7eaf3;
}

.custom-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.03);
}

/* Optional hover effect */
.custom-striped tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.08) !important;
}
</style>
